<template>
  <div class="about">
    <AboutDetails />
    <Slide/>
    <h1>Our Portfolio</h1>
    <Portifolio />
    <Footer />
  </div>
</template>

<script>
import AboutDetails from "../components/AboutDetails"
import Slide from "../components/Slide"
import Portifolio from "../components/Portifolio"
import Footer from "../components/layouts/Footer";
  export default {
    components:{
      AboutDetails,
      Portifolio,
      Slide,
      Footer
    }
  }
</script>

<style scoped>
.about{
  max-width: 1400px;
  margin: auto;
}
h1{
   color: #343540;
  font-family: "DM Sans";
  font-size: 36px;
  font-weight: 700;
  line-height: 47px;
  text-align: center;
}
</style>
